import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Car } from "models";

type DBBAppointmentDatePayload = {
  appointment_id: number;
  dbb_appointment_date: string;
};

export const useDBBAppointmentDate = () =>
  useTypedMutation<DBBAppointmentDatePayload, Car>({
    mutationFn: async payload => (await ApiInstance.post("/dbb/appointment_date/update", payload, ENV.appointmentBaseURL)).data,
    onSuccess: (payload, car) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment || appointment.id !== payload.appointment_id) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, ...car } });
    }
  });
